import React, { useEffect, useState } from 'react'
import { FaQuestion } from 'react-icons/fa'

type IconProps = {
  lib: string // ex: "fa", "md", "ai"
  name: string // ex: "FaBeer", "MdHome"
  color?: string
  size?: number
}

const DynamicIcon: React.FC<IconProps> = ({ lib, name, color, size }) => {
  const [Icon, setIcon] =
    useState<React.ComponentType<{ color?: string; size?: number }> | null>(
      null
    )

  useEffect(() => {
    switch (lib) {
      case 'gi':
        import(`react-icons/gi`).then(icons => {
          setIcon(
            () =>
              (
                icons as unknown as {
                  [key: string]: React.ComponentType<{
                    color?: string
                    size?: number
                  }>
                }
              )[name]
          )
        })
        break
      default:
        setIcon(() => FaQuestion)
        break
    }
  }, [lib, name])

  if (!Icon) return null
  return <Icon color={color} size={size} />
}

export default DynamicIcon
